import { render, staticRenderFns } from "./BoardComponent.vue?vue&type=template&id=0d809130&scoped=true&"
import script from "./BoardComponent.vue?vue&type=script&lang=ts&"
export * from "./BoardComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BoardComponent.vue?vue&type=style&index=0&id=0d809130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d809130",
  null
  
)

export default component.exports